import * as React from "react";

function SvgPendo(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 798.84 182.74"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <defs>
        <style>{".Pendo_svg__cls-1{fill:#2a2c35}"}</style>
      </defs>
      <g id="Pendo_svg__Layer_2" data-name="Layer 2">
        <g id="Pendo_svg__Layer_1-2" data-name="Layer 1">
          <path
            className="Pendo_svg__cls-1"
            d="M259 36.7a53.92 53.92 0 00-36.89 14.47V36.58h-17.45v146.16h17.48V131A54.35 54.35 0 10259 36.7zm36.89 54.36A36.89 36.89 0 11259 54.18a36.93 36.93 0 0136.91 36.89zM381.18 36.58a54.36 54.36 0 000 108.73c16.79 0 32.2-6.29 42.28-17.24l5.24-5.69.68-.74-.74-.68-11.39-10.48-.74-.68-.68.74-5.24 5.7c-6.68 7.26-17.68 11.6-29.42 11.6a37 37 0 01-35.84-28.15h88.8v-8.75c.01-30.48-23.25-54.36-52.95-54.36zm-35.84 45.63a37 37 0 0135.84-28.15c16.75 0 30.78 11.51 34.52 28.15zM500.24 36.58a49.55 49.55 0 00-33.72 13.33V36.58h-17.47v109.58h17.48V90.24c0-20 15.12-36.18 33.72-36.18S534 70.29 534 90.24v55.92h17.48V90.24c-.04-29.59-23.01-53.66-51.24-53.66zM658.49 0h-1v51.78a54.36 54.36 0 100 79.79v14.59H675V0h-16.51zm-1 91.67a36.89 36.89 0 11-36.89-36.88 36.93 36.93 0 0136.89 36.88zM744.47 37.31a54.36 54.36 0 1054.37 54.37 54.43 54.43 0 00-54.37-54.37zm36.89 54.37a36.89 36.89 0 11-36.89-36.89 36.93 36.93 0 0136.89 36.88z"
          />
          <path
            fill="#eb225a"
            d="M82.06 18.62L0 100.68h82.06v82.06l82.07-82.06V18.62H82.06z"
          />
        </g>
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgPendo);
